import { Plan } from "../Plan/PlanModel";
import { SoulDataModel } from "./SoulDataModel";

export class PaymentDataModel {
  id: string;
  userId: string;
  planCode: string;
  stripeSessionId?: string;
  clientSecret?: string;
  status: string;
  amountUsd: number;
  currency: string;
  metadata?: any;
  createdAt: Date;
  updatedAt: Date;
  plan?: Plan;
  soul?: SoulDataModel;

  constructor(data: any) {
    this.id = data.id;
    this.userId = data.userId || data.user_id;
    this.planCode = data.planCode || data.plan_code;
    this.stripeSessionId =
      data.stripeSessionId || data.stripe_session_id || null;
    this.clientSecret = data.clientSecret || data.client_secret || null;
    this.status = data.status;
    this.amountUsd = Number(data.amountUsd || data.amount_usd || 0);
    this.currency = data.currency || "USD";
    this.metadata = data.metadata || null;
    this.createdAt = new Date(data.createdAt || data.created_at);
    this.updatedAt = new Date(data.updatedAt || data.updated_at);
    this.plan = data.plan || null;
    this.soul = data.soul || null;
  }
}
